// framework
import { immerable, produce } from "immer";
// api
import * as Client from "../../../../api/Client";
import { CallResultError } from "../../../../api/callHelper";

export interface IRootViewModel {
    readonly filter: string;
    readonly isBusy: boolean;
    readonly error: CallResultError | undefined;
    readonly titles: Client.GetPublicTitlesListItemDto[];

    titlesLoading(filter: string): IRootViewModel;
    titlesLoaded(response: Client.GetPublicTitlesListResponseDto | undefined, error: CallResultError | undefined): IRootViewModel;
}

export class RootViewModel implements IRootViewModel {
    [immerable] = true;

    constructor() {
        this.filter = "";
        this.isBusy = false;
        this.error = undefined;
        this.titles = [];
    }
    public readonly filter: string;
    public readonly isBusy: boolean;
    public readonly error: CallResultError | undefined;
    public readonly titles: Client.GetPublicTitlesListItemDto[];

    public titlesLoading(filter: string): IRootViewModel {
        return produce(this, (draft) => {
            draft.isBusy = true;

            draft.filter = filter;
            // current results are no longer valid
            draft.titles = [];
        });
    }

    public titlesLoaded(response: Client.GetPublicTitlesListResponseDto | undefined, error: CallResultError | undefined): IRootViewModel {
        return produce(this, (draft) => {
            draft.titles = response?.titles ?? [];

            draft.isBusy = false;
            draft.error = error;
        });
    }
}
